
import Api from './api'

export default {
    get: function (email) {

        return Api.get(`/auth/mx/${ email }`)
    }
}
